<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('razas')">Razas</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Editar
    </h1>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            v-model="form.nombre"
            :error="form.errors.nombre"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Nombre"
            required
          />

          <select-input
            v-model="form.especie_id"
            :error="form.errors.especie_id"
            class="pr-6 pb-8 w-full lg:w-1/2"
            label="Especie"
            required
          >
            <option :value="null" disabled>Seleccione</option>
            <option v-for="e in especies" :key="e.id" :value="e.id">
              {{ e.nombre }}
            </option>
          </select-input>
        </div>

        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Actualizar Raza
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Editar Raza' },
  layout: Layout,
  components: { TextInput, SelectInput, LoadingButton },
  props: {
    raza: Object,
    especies: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombre: this.raza.nombre || null,
        especie_id: this.raza.especie_id || null,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('razas.update', { raza: this.raza.id }))
    },
  },
}
</script>